var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradeMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "14px",
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "trade_more") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-554, -166)",
    fill: "#0E1C39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(555, 167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,0 L13,0 C13.5522847,-1.01453063e-16 14,0.44771525 14,1 C14,1.55228475 13.5522847,2 13,2 L1,2 C0.44771525,2 3.38176876e-17,1.55228475 0,1 C-6.76353751e-17,0.44771525 0.44771525,6.76353751e-17 1,0 Z",
    id: "\\u77E9\\u5F62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,5 L13,5 C13.5522847,5 14,5.44771525 14,6 C14,6.55228475 13.5522847,7 13,7 L7,7 C6.44771525,7 6,6.55228475 6,6 C6,5.44771525 6.44771525,5 7,5 Z",
    id: "\\u77E9\\u5F62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,5 L3,5 C3.55228475,5 4,5.44771525 4,6 C4,6.55228475 3.55228475,7 3,7 L1,7 C0.44771525,7 3.38176876e-17,6.55228475 0,6 C-6.76353751e-17,5.44771525 0.44771525,5 1,5 Z",
    id: "\\u77E9\\u5F62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,10 L13,10 C13.5522847,10 14,10.4477153 14,11 C14,11.5522847 13.5522847,12 13,12 L1,12 C0.44771525,12 3.38176876e-17,11.5522847 0,11 C-6.76353751e-17,10.4477153 0.44771525,10 1,10 Z",
    id: "\\u77E9\\u5F62"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeMore);
export default __webpack_public_path__ + "static/media/trade_more.d9d6fa5d1c2ef05c2543d73386f8e056.svg";
export { ForwardRef as ReactComponent };